// utils/wishlistUtils.js
import axios from "axios";

import "react-toastify/dist/ReactToastify.css";

const admin_auto_id = sessionStorage.getItem("admin_auto_id");
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addToWishlist = async (product_id) => {
  const customer_auto_id = sessionStorage.getItem("accessToken");

  if (!customer_auto_id) {
    return { status: "0", triggerVibration: true };
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/add_to_wishlist`,
      {
        admin_auto_id: admin_auto_id,
        user_auto_id: customer_auto_id,
        product_auto_id: product_id,
      }
    );

    if (response.data.status === "1") {
      window.dispatchEvent(new Event("wishlist-updated"));
    }
    return response.data;

  } catch (error) {
    console.error("Add to wishlist error:", error);
    return { status: "0" };
  }
};

export const removeFromWishlist = async (product_id) => {
  const customer_auto_id = sessionStorage.getItem("accessToken");

  if (!customer_auto_id) {
    return { status: "0", triggerVibration: true };
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/delete_wishlist_item`,
      {
        admin_auto_id,
        user_auto_id: customer_auto_id,
        product_auto_id: product_id,
      }
    );

    if (response.data.status === 1) {
      window.dispatchEvent(new Event("wishlist-updated"));
    }
    return response.data;
  } catch (error) {
    console.error("Remove from wishlist error:", error);
    return { status: "0" };
  }
};


export const getWishlistCount = async () => {
  try {
    const user_auto_id = sessionStorage.getItem("accessToken");

    if (!user_auto_id || !admin_auto_id) return 0;

    const response = await axios.post(
      `${BASE_URL}/get_wishlist_product_count`,
      {
        admin_auto_id,
        user_auto_id,
      }
    );

    if (response.data.status === 1) {
      return response.data.product_count_data;
    } else {
      return 0;
    }
  } catch (error) {
    console.error("Error fetching wishlist count:", error);
    return 0;
  }
};

export const getWishlistProducts = async () => {
  const user_auto_id = sessionStorage.getItem("accessToken");
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");

  if (!user_auto_id || !admin_auto_id) return [];

  try {
    const res = await axios.post(
     `${process.env.REACT_APP_API_BASE_URL}/get_wishlist`,
      {
        admin_auto_id,
        user_auto_id,
      }
    );

    if (res.data.status === 1) {
      return res.data.get_admin_wishlist_product_lists || [];
    }

    return [];
  } catch (error) {
    console.error("getWishlistProducts error:", error);
    return [];
  }
};